module.exports = __webpack_public_path__ + "static/media/coffee.0c7d8867.svg";